import React, {useEffect} from 'react';

import {CompetitionsSliderWidgetProps} from "../../models/competitions-slider-widget.props";
import {PoweredByStrip} from "../../../../core/components/misc/powered-by-strip/powered-by-strip";
import {Image} from "../../../../core/components/image/image";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";

export class CompetitionsSliderWidgetOddsTransparentProps extends CompetitionsSliderWidgetProps {
}

export const CompetitionsSliderWidgetOddsTransparent = (({controller}: CompetitionsSliderWidgetOddsTransparentProps) => {
  const {state} = controller;
  const {sponsorshipBookmaker, appSettings, currentLinkModel, sponsoredBookmakerVisible, shouldRenderPoweredBy} = state;
  useEffect(() => {
    controller.action(ACTION_TYPES.betsImpressionsShow, {
      bookieId: sponsorshipBookmaker.id,
      bookieName: sponsorshipBookmaker.name,
      widget: APP.GOOGLE_ANALYTICS.SOURCES.slider,
      currentLinkModelName: currentLinkModel.name,
      impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.main,
      source: APP.ANALYTICS.SOURCES.slider
    })
  }, []);

  const poweredByStripProps = {
    className: 'competitions-slider-widget-powered-by-strip',
    controller,
    i18n: state.terms,
    title: state.terms.WIDGET_POWERED_BY
  }

  const logoProps = {
    className: ['competitions-slider-widget-bar-odds-bookie', 'clickable'].join(' '),
    src: new sponsorshipBookmaker.darkTransparentLogoType({height: 32}, sponsorshipBookmaker),
    onClick: () => controller.action(ACTION_TYPES.bookieClickEvent, {
      urlLink: appSettings.publisherSettings.bookmakerUrl || sponsorshipBookmaker.link,
      currentLinkModelName: currentLinkModel.name,
      bookieId: sponsorshipBookmaker.id,
      bookieName: sponsorshipBookmaker.name,
      impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.main,
      widget: APP.GOOGLE_ANALYTICS.SOURCES.slider,
      hasOdds: !!sponsorshipBookmaker,
      buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER.bookie,
    }),
  }

  return (
    <>
      {
        sponsoredBookmakerVisible &&
        <>
          <div className={'competitions-slider-widget-bar-odds-by'}>{state.terms.WIDGET_ODDS_BY}</div>
          <Image {...logoProps} />
        </>
      }
      {
        shouldRenderPoweredBy && <PoweredByStrip {...poweredByStripProps}/>
      }
    </>
  )
});
